<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div
    id="kt_app_toolbar_container"
    class="app-container container-fluid d-flex flex-stack"
  >
    <!--begin::Page title-->
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
    >
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading mt-0 mb-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="38"
            viewBox="0 0 39 38"
            fill="none"
          >
            <g filter="url(#filter0_d_2093_798)">
              <path
                d="M32.8286 12.3011C32.8286 12.0526 32.7289 11.8142 32.5514 11.6385C32.374 11.4627 32.1334 11.364 31.8824 11.364H22.0522C21.8013 11.364 21.5607 11.4627 21.3832 11.6385C21.2058 11.8142 21.1061 12.0526 21.1061 12.3011V26.7139H19.4062V28.5881H34.2761V26.7139H32.8286V12.3011ZM22.9984 13.2382H30.9363V26.7139H22.9984V13.2382Z"
                fill="#265D91"
              />
              <path
                d="M25.4293 14.191H23.5371V17.0211H25.4293V14.191Z"
                fill="#265D91"
              />
              <path
                d="M27.9508 14.191H26.0586V17.0211H27.9508V14.191Z"
                fill="#265D91"
              />
              <path
                d="M30.4684 14.191H28.5762V17.0211H30.4684V14.191Z"
                fill="#265D91"
              />
              <path
                d="M25.4293 18.5611H23.5371V21.3912H25.4293V18.5611Z"
                fill="#265D91"
              />
              <path
                d="M27.9508 18.5611H26.0586V21.3912H27.9508V18.5611Z"
                fill="#265D91"
              />
              <path
                d="M30.4684 18.5611H28.5762V21.3912H30.4684V18.5611Z"
                fill="#265D91"
              />
              <path
                d="M25.4293 22.928H23.5371V25.7581H25.4293V22.928Z"
                fill="#265D91"
              />
              <path
                d="M27.9508 22.928H26.0586V25.7581H27.9508V22.928Z"
                fill="#265D91"
              />
              <path
                d="M30.4684 22.928H28.5762V25.7581H30.4684V22.928Z"
                fill="#265D91"
              />
              <path
                d="M17.4223 2.3491C17.4223 2.10056 17.3226 1.8622 17.1452 1.68646C16.9678 1.51072 16.7271 1.41199 16.4762 1.41199H6.64599C6.39506 1.41199 6.15441 1.51072 5.97698 1.68646C5.79954 1.8622 5.69986 2.10056 5.69986 2.3491V16.7619H4V18.6361H18.8699V16.7619H17.4223V2.3491ZM7.59211 3.28621H15.5301V16.7619H7.59211V3.28621Z"
                fill="#265D91"
              />
              <path
                d="M10.0231 4.24194H8.13086V7.07202H10.0231V4.24194Z"
                fill="#265D91"
              />
              <path
                d="M12.5465 4.24194H10.6543V7.07202H12.5465V4.24194Z"
                fill="#265D91"
              />
              <path
                d="M15.0661 4.24194H13.1738V7.07202H15.0661V4.24194Z"
                fill="#265D91"
              />
              <path
                d="M10.0231 8.60901H8.13086V11.4391H10.0231V8.60901Z"
                fill="#265D91"
              />
              <path
                d="M12.5465 8.60901H10.6543V11.4391H12.5465V8.60901Z"
                fill="#265D91"
              />
              <path
                d="M15.0661 8.60901H13.1738V11.4391H15.0661V8.60901Z"
                fill="#265D91"
              />
              <path
                d="M10.0231 12.9758H8.13086V15.8059H10.0231V12.9758Z"
                fill="#265D91"
              />
              <path
                d="M12.5465 12.9758H10.6543V15.8059H12.5465V12.9758Z"
                fill="#265D91"
              />
              <path
                d="M15.0661 12.9758H13.1738V15.8059H15.0661V12.9758Z"
                fill="#265D91"
              />
              <path
                d="M30.3343 8.19659H32.2266V2.93003H25.9727V0L20.3086 3.82341L25.9853 7.61871V4.80738H30.3469L30.3343 8.19659ZM23.6768 3.82341L24.0742 3.55477V4.08892L23.6768 3.82341Z"
                fill="#265D91"
              />
              <path
                d="M7.94107 21.8035H6.04883V27.07H12.3027V30.0001L17.9668 26.1766L12.2901 22.3814V25.1927H7.92845L7.94107 21.8035ZM14.5986 26.1766L14.2012 26.4453V25.9174L14.5986 26.1766Z"
                fill="#265D91"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_2093_798"
                x="0"
                y="0"
                width="38.2754"
                height="38.0001"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2093_798"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2093_798"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>

          Entreprises
        </h1>

        <!--begin::Menu-->
      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul
        class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
      >
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Entreprises</li>

        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card">
      <!--begin::Card header-->

      <div class="card-body" [formGroup]="searchForm">
        <div class="title mb-3 d-flex justify-content-between">
          <h4>{{ freeSearch ? 'Recherche libre ' : 'Recherche avancée' }}</h4>
          <a (click)="displayFreeSearch()" class="action-btn show-more-button">
            {{ freeSearch ? 'Recherche avancée' : 'Recherche libre' }}
            <i class="ms-2 fa fa-paper-plane" style="color: #fff;"></i>
          </a>
        </div>
        <div [formGroup]="freeSearchForm" (click)="setActiveForm('freeSearch')">
          <div class="row mb-5">
            <div class="col-lg-6" [ngClass]="{'search-free-hide': !freeSearch, 'search-free-block': freeSearch}">
              <div class="input-group search-libre">
                <span class="input-group-text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                      fill="#7E7C7C"
                    />
                  </svg>
                </span>
  
                <input
                  type="text"
                  data-kt-customer-table-filter="search"
                  class="form-control ps-5"
                  placeholder="Rechercher"
                  formControlName="search"
                />
                <div class="tooltip-container tooltip-info">
                  <div class="tooltip-trigger">
                    <i
                      class="fa-solid fa-circle-info"
                      style="font-size: 20px"
                    ></i>
                  </div>
                  <div class="tooltip-content">
                    <div class="content">
                      <h4>Opérateur AND :</h4>
                      <p>
                        Utilisez l'opérateur AND pour spécifier que les résultats
                        doivent inclure plusieurs termes.
                      </p>
                      <p>
                        Exemple : software AND engineer renverra des profils qui
                        mentionnent à la fois "software" et "engineer".
                      </p>
                      <h4>Opérateur OR :</h4>
                      <p>
                        Utilisez l'opérateur OR pour spécifier que les résultats
                        peuvent inclure l'un des termes.
                      </p>
                      <p>
                        Exemple : sales OR marketing renverra des profils qui
                        mentionnent soit "sales" soit "marketing".
                      </p>
                      <h4>Opérateur NOT :</h4>
                      <p>
                        Utilisez l'opérateur NOT pour exclure des termes
                        spécifiques des résultats.
                      </p>
                      <p>
                        Exemple : developer NOT manager renverra des profils qui
                        mentionnent "developer" mais pas "manager".
                      </p>
                      <h4>Guillemets pour une expression exacte :</h4>
                      <p>
                        Utilisez des guillemets pour rechercher une expression
                        exacte.
                      </p>
                      <p>
                        Exemple : "product manager" renverra des profils qui
                        mentionnent exactement "product manager".
                      </p>
                      <h4>Parenthèses pour grouper des opérations :</h4>
                      <p>
                        Utilisez des parenthèses pour définir l'ordre d'évaluation
                        des opérations.
                      </p>
                      <p>
                        Exemple : (sales OR marketing) AND manager renverra des
                        profils qui mentionnent "sales" ou "marketing" et
                        "manager".
                      </p>
                      <h4>Recherche standard :</h4>
                      <p>
                        Si aucun opérateur n'est spécifié dans la recherche, le
                        texte sera interprété comme s'il était entre guillemets.
                      </p>
                      <p>
                        Exemple : La recherche product manager sera traitée comme
                        "product manager", suivant la règle 4.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        <div [formGroup]="searchForm"  (click)="setActiveForm('guidedSearch')" 
        [ngClass]="{'search-free-hide': freeSearch, 'search-free-block': !freeSearch}">
          <div class="tools" [formGroup]="searchForm">
            <div class="row mb-3">
              <!-- <div class="col-lg-3">
                <div class="me-md-2 mb-3">
                  <input
                    type="text"
                    formControlName="ID_company"
                    class="form-control form-control-solid ps-5"
                    name="société"
                    placeholder="ID"
                  />
                </div>
              </div> -->
              <div class="col-lg-3">
                <div class="me-md-2 mb-3">
                  <input
                    type="text"
                    formControlName="name"
                    class="form-control form-control-solid ps-5"
                    name="société"
                    placeholder="Nom Entreprise"
                  />
                </div>
              </div>
              <div class="col-lg-3">
                <div class="me-md-2 mb-3">
                  <ng-select
                    formControlName="typeComp"
                    [items]="typeCompany"
                    bindLabel="name"
                    bindValue="id"
                    [notFoundText]="'Aucun élément trouvé'"
                    [placeholder]="'Type'"
                    autoComplete
                  >
                  </ng-select>
                </div>
              </div>
  
              <div class="col-lg-3">
                <ng-select
                  formControlName="country"
                  [items]="paysList"
                  bindLabel="name"
                  bindValue="name"
                  class="mb-3"
                  [notFoundText]="'Aucun élément trouvé'"
                  [placeholder]="'Pays'"
                  [multiple]="true"
                  autoComplete
                >
                </ng-select>
              </div>
  
              <!-- <div class="col-lg-3">
                              <label for="">Avis</label>
                              <div class="stars">
                                  <rating formControlName="note" [titles]="[' ',' ',' ',' ',' ']" [max]="5"
                                      class="rating-stars " (click)="handleRatingClick($event)">
                                  </rating>
                              </div>
  
                          </div> -->
            </div>
  
            
          </div>
        </div>
        <div class="row mb-3"   [ngClass]="{'free-search': !freeSearch, 'search-form':freeSearch}">
          <div class="col-lg-3"></div>
          <div class="col-lg-3"></div>
          <div class="col-lg-3"></div>
          <div class="mb-3 search-btn d-flex justify-content-end">
            <div class="align-items-center recherche">
              <button type="button" class="me-5" (click)="onSubmit(); startSearching = true">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                    fill="white"
                  />
                </svg>
                Rechercher
              </button>
            </div>
            <div class="resett-btn">
              <div
                class="reset-icon cursor-pointer"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Réinitialiser"
              >
                <a (click)="reset()">
                  <img src="/assets/media/icons/reset.png" alt="" width="30px"
                /></a>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>

  <!--end::Content container-->
</div>
<div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card content-table">
      <!--begin::Card header-->
      <div class="d-flex flex-wrap header-grid align-items-center">
        <div class="section_title">
          <h1 class="section-heading my-0">Liste des entreprises</h1>
        </div>
        <!--begin::Tab nav-->
        <ul class="nav nav-pills me-5" *ngIf="listCampany && listCampany.length">
          <li class="nav-item m-0">
            <a
              class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
              data-bs-toggle="tab"
              href="#kt_project_targets_card_pane"
            >
              <i class="ki-duotone ki-element-plus fs-1">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
              </i>
            </a>
          </li>
          <li class="nav-item m-0">
            <a
              class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
              data-bs-toggle="tab"
              href="#kt_project_targets_table_pane"
            >
              <i class="ki-duotone ki-row-horizontal fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </a>
          </li>
        </ul>
        <!--end::Tab nav-->
        <!--begin::Wrapper-->
        <!--end::Wrapper-->
      </div>
      <!--end::Card header-->
      <!--begin::Card body-->
      <div class="card-body pt-0">
        <div class="tab-content for-web">
          <!--begin::Tab pane-->

          <div id="kt_project_targets_card_pane" class="tab-pane fade">
            <!--begin::Row-->
            <div class="row g-6 g-xl-9 justify-content-center">
              <!--begin::Col-->
              <div
                class="col-md-6 col-xxl-4"
                *ngFor="let data of listCampany; let i = index"
              >
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="card-toolbar1">
                    <span
                      [ngClass]="
                        data?.company?.type == '1'
                          ? 'entreprise'
                          : data?.company?.type == '2'
                          ? 'esn-type'
                          : data?.company?.type == '3'
                          ? 'client-type'
                          : 'cabinet-type'
                      "
                      class="type-esn text-uppercase wrapping-company fw-bold"
                    >
                      {{
                        data?.company?.type == "1"
                          ? "Entreprise"
                          : data?.company.type == "2"
                          ? "ESN"
                          : data?.company.type == "3"
                          ? "Client Final"
                          : "Cabinet de Recrutement"
                      }}</span
                    >
                  </div>

                  <div class="tools">
                    <td class="actions">
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <svg
                              width="19"
                              height="5"
                              viewBox="0 0 19 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91"
                              />
                            </svg>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item btn-details"
                              routerLink="/entreprises/details-entreprise/{{
                                data.company.uuid
                              }}"
                              style="cursor: pointer"
                              >Visualiser</a
                            >
                             
                             <a mat-menu-item
                                  class="dropdown-item btn-details cursor-pointer"
                                  [ngClass]="{'disabled-button': unSubscribedEsn() || data.company?.hasActiveSubscription === false}"
                                  *ngIf="!unSubscribedEsn()" 
                                  [href]="'/contact;idResponsable=' + data.company?.uuid + ';Type=' + data.company?.type"
                                  style="cursor: pointer"
                                >
                              Contacter responsable
                            </a>

                            <a
                              class="dropdown-item"
                              style="cursor: pointer"
                              (click)="VoiroffreNavigation(data.company?.uuid)"
                              >Voir offres</a
                            >
                          </div>
                        </div>
                      </div>
                    </td>
                  </div>
                  <!--begin::Card body-->
                  <div class="card-body d-flex flex-center flex-column">
                    <!--begin::Avatar-->
                    <div class="symbol symbol-65px symbol-circle mb-5">
                      <img
                        class="table-img logo-img"
                        [src]=" data?.company.logo
                            ? url +
                              '/Company/file/gallery_company/' +
                              data?.company.logo
                            : '' "
                        alt=""
                      />

                      <div
                        class="bg-success position-absolute top-100 ms-n3 mt-n3"
                      ></div>
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Name-->
                    <!-- fs-4 text-gray-800 text-hover-primary fw-bold mb-0 -->
                    <a
                      class="entreprise_name"
                      routerLink="/entreprises/details-entreprise/{{
                        data.company.uuid
                      }}"
                    >
                      {{ data.company?.name
                          ? data.company?.name
                          : "---"
                      }}
                    </a>

                    <div class="content-card">
                      <!--begin::Stats-->

                      <div class="py-3 px-4 mx-2">
                        <div class="ratings">
                          <rating
                            [(ngModel)]="data.average_note"
                            [max]="5"
                            [readonly]="true"
                          >
                          </rating>
                        </div>
                      </div>
                    </div>

                    <!--end::Info-->
                  </div>
                  <div class="foot p-5">
                    <div class="links">
                      <a
                        *ngIf="data?.company.linkedin_link"
                         [href]="formatUrl(data.company.linkedin_link)"
                       target="_blank"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 17 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_239_1206)">
                            <path
                              d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                              fill="#265D91"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_239_1206">
                              <rect width="17" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                      <a
                        *ngIf="data?.company?.website_link"
                        [href]="formatUrl(data.company.website_link)"
                        target="_blank"
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.0410156"
                            y="0.0407715"
                            width="17.9592"
                            height="17.9592"
                            rx="3"
                            fill="#265D91"
                          />
                          <path
                            d="M8.72077 14.4082C5.4083 14.4082 2.73438 12.0017 2.73438 9.02045C2.73438 6.03922 5.4083 3.63269 8.72077 3.63269C12.0332 3.63269 14.7072 6.03922 14.7072 9.02045C14.7072 12.0017 12.0332 14.4082 8.72077 14.4082ZM8.72077 4.35106C5.8473 4.35106 3.53256 6.43432 3.53256 9.02045C3.53256 11.6066 5.8473 13.6898 8.72077 13.6898C11.5942 13.6898 13.909 11.6066 13.909 9.02045C13.909 6.43432 11.5942 4.35106 8.72077 4.35106Z"
                            fill="white"
                          />
                          <path
                            d="M11.833 10.3494C11.9128 9.91841 11.9128 9.48738 11.9128 9.02045C11.9128 8.55351 11.8729 8.12249 11.833 7.69147C11.7532 7.11677 11.5936 6.578 11.4339 6.07514C10.8353 4.60249 9.87746 3.63269 8.72009 3.63269C7.36317 3.63269 6.24571 4.96167 5.7668 6.90126C5.72689 7.08085 5.68698 7.22453 5.64707 7.40412C5.56725 7.90698 5.52734 8.44575 5.52734 9.02045C5.52734 9.48738 5.56725 9.91841 5.60716 10.3494C5.68698 10.9241 5.84662 11.4629 6.00626 11.9658C6.56499 13.4384 7.56272 14.4082 8.68018 14.4082C9.79764 14.4082 10.7954 13.4384 11.3541 11.9658C11.0747 12.0376 10.7555 12.0735 10.4362 12.1453C10.0371 13.1151 9.35864 13.6898 8.72009 13.6898C8.08154 13.6898 7.40308 13.1151 6.96408 12.1453C6.76453 11.7143 6.60489 11.1755 6.48517 10.6009C6.36544 10.098 6.32553 9.59514 6.32553 9.02045C6.32553 8.44575 6.36544 7.90698 6.48517 7.44004C6.52508 7.26045 6.56499 7.11677 6.60489 6.93718V6.90126C6.6448 6.72167 6.68471 6.578 6.76453 6.43432C6.80444 6.32657 6.84435 6.21881 6.88426 6.14698C6.88426 6.14698 6.88426 6.14698 6.88426 6.11106L6.96408 5.96738C6.96408 5.96738 6.96408 5.93147 7.00399 5.89555C7.40308 4.92575 8.08154 4.35106 8.72009 4.35106C9.35864 4.35106 10.0371 4.92575 10.4761 5.89555C10.6756 6.32657 10.8353 6.86534 10.955 7.44004C11.0747 7.94289 11.1146 8.44575 11.1146 9.02045C11.1146 9.59514 11.0747 10.098 10.9949 10.6009C11.2743 10.529 11.5536 10.4572 11.833 10.3494Z"
                            fill="white"
                          />
                          <path
                            d="M11.9933 6.61416C11.4745 6.43456 10.836 6.32681 10.1974 6.25497C9.7185 6.18314 9.23959 6.14722 8.72077 6.14722C8.20195 6.14722 7.72304 6.18314 7.24412 6.21905C7.16431 6.43456 7.04458 6.68599 6.96476 6.97334C7.52349 6.9015 8.08222 6.86558 8.72077 6.86558C9.35932 6.86558 9.91805 6.9015 10.4768 6.97334C11.1153 7.08109 11.714 7.22477 12.1929 7.40436C13.2704 7.83538 13.909 8.41007 13.909 8.98477C13.909 9.55946 13.2704 10.1701 12.1929 10.5652C11.714 10.7448 11.1153 10.8884 10.4768 10.9962C9.91805 11.1399 9.35932 11.1758 8.72077 11.1758C8.08222 11.1758 7.52349 11.1399 6.96476 11.0321C6.32621 10.9603 5.72757 10.8166 5.24866 10.6011C4.17111 10.206 3.53256 9.59538 3.53256 9.02069C3.53256 8.44599 4.17111 7.83538 5.24866 7.44028C5.28857 7.15293 5.36839 6.86558 5.44821 6.61416C3.81193 7.11701 2.73438 7.97905 2.73438 9.02069C2.73438 10.0623 3.81193 10.9244 5.44821 11.4272C5.96703 11.6068 6.60558 11.7146 7.24412 11.7864C7.72304 11.8582 8.20195 11.8582 8.72077 11.8582C9.23959 11.8582 9.7185 11.8223 10.1974 11.7864C10.836 11.7146 11.4745 11.5709 11.9933 11.4272C13.6296 10.9244 14.7072 10.0264 14.7072 9.02069C14.7072 8.01497 13.6296 7.11701 11.9933 6.61416Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </div>

                    <div class="plus">
                      <a
                        style="cursor: pointer"
                        routerLink="/entreprises/details-entreprise/{{
                          data.company.uuid
                        }}"
                        >Visualiser</a
                      >
                    </div>
                  </div>
                  <!--end::Card body-->
                </div>
                <!--end::Card-->
              </div>
              <!--end::Col-->
            </div>
            <div class="pagination" *ngIf="listCampany && listCampany.length">
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                aria-label="Select page">
              </mat-paginator>
            </div>
          
            <app-empty-state *ngIf="listCampany && !listCampany.length"
                                            [title]="parentItem"></app-empty-state>
            <!--end::Row-->
          </div>
          <!--end::Tab pane-->
          <!--begin::Tab pane-->
          <div
            id="kt_project_targets_table_pane"
            class="tab-pane fade show active"
          >
            <div class="content">
              <div class="card-body pt-3 pb-0">
                <!--begin::Table-->
                <div class="table-responsive"  id="kt_customers_table" *ngIf="listCampany && listCampany.length">
                  <table
                    class="table align-middle gy-5">
                    <thead>
                      <tr
                        class="text-start text-gray-400 fw-bold text-uppercase gs-0">
                        <ng-container
                          *ngFor="let item of listNames; let i = index"
                        >
                          <th
                            class="min-w-175px"
                            *ngIf="!['Dernière connexion'].includes(item)"
                            [ngClass]="{ 'th-fixed': item === 'Entreprise' }"
                          >
                            <span>{{ item }}</span>
                          </th>
                        </ng-container>

                        <th class="min-w-90px stiky-column-action"><span>Actions</span></th>
                        <th class="min-w-30px stiky-column">
                          <div class="dropdown">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                              >
                                <g filter="url(#filter0_d_588_1699)">
                                  <rect
                                    x="4"
                                    width="20"
                                    height="20"
                                    rx="4"
                                    fill="#63C3E8"
                                    fill-opacity="0.12"
                                    shape-rendering="crispEdges"
                                  />
                                </g>
                                <path
                                  d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                  fill="#265D91"
                                  stroke="#265D91"
                                  stroke-width="0.2"
                                />
                                <defs>
                                  <filter
                                    id="filter0_d_588_1699"
                                    x="0"
                                    y="0"
                                    width="28"
                                    height="28"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                  >
                                    <feFlood
                                      flood-opacity="0"
                                      result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                      in="SourceAlpha"
                                      type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                      result="hardAlpha"
                                    />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite
                                      in2="hardAlpha"
                                      operator="out"
                                    />
                                    <feColorMatrix
                                      type="matrix"
                                      values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in2="BackgroundImageFix"
                                      result="effect1_dropShadow_588_1699"
                                    />
                                    <feBlend
                                      mode="normal"
                                      in="SourceGraphic"
                                      in2="effect1_dropShadow_588_1699"
                                      result="shape"
                                    />
                                  </filter>
                                </defs>
                              </svg>
                            </button>
                            <div class="dropdown-table">
                              <div
                                class="dropdown-menu list-actions-content"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div
                                  class="d-flex checkbox mb-2 menu"
                                  *ngFor="let item of dataHeader; let i = index"
                                >
                                  <div
                                    class="form-check form-check-sm form-check-custom form-check-solid"
                                    *ngIf="item.name != 'checkbox'"
                                  >
                                    <input
                                      class="form-check-input checkbox-border"
                                      [checked]="
                                        (item.checked == 'oui' &&
                                          !item.checked_user) ||
                                        (item.checked_user == 'oui' &&
                                          (item.checked == 'non' ||
                                            item.checked == 'oui'))
                                      "
                                      (change)="
                                        changeSelection($event, item, i)
                                      "
                                      type="checkbox"
                                      value="1"
                                      *ngIf="
                                        !['Dernière connexion'].includes(
                                          item.name
                                        )
                                      "
                                      [disabled]="
                                        item.name === 'Entreprise' ||
                                        item.name === 'Logo'
                                      "
                                    />
                                    <a
                                      *ngIf="
                                        !['Dernière connexion'].includes(
                                          item.name
                                        )
                                      "
                                      class="dropdown-item"
                                      >{{ item.name }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="fw-semibold text-gray-600">
                      <tr *ngFor="let data of listCampany; let i = index">
                        <!-- <td *ngIf="listNames.includes('ID')">
                          <a
                            class="first-td"
                            routerLink="/entreprises/details-entreprise/{{
                              data.company.uuid
                            }}"
                            >{{ data.company?.ID_company }}
                          </a>
                        </td> -->
                        <td *ngIf="listNames.includes('Logo')">
                          <img
                            class="table-img logo-img"
                            [src]="data?.company.logo
                                ? url +
                                  '/Company/file/gallery_company/' +
                                  data?.company.logo
                                : '/assets/media/icons/avatar.jpg'
                            "
                            alt=""
                          />
                        </td>
                        <td
                          *ngIf="listNames.includes('Entreprise')"
                          class="td-fixed"
                        >
                          <span
                            class="first-td"
                            routerLink="/entreprises/details-entreprise/{{
                              data.company.uuid
                            }}"
                          >
                            {{ data.company?.name ? data.company?.name : "---" }}
                          </span>
                        </td>
                        <td *ngIf="listNames.includes('Type')">
                          <span
                            class="wrapping"
                            [ngClass]="
                              data?.company?.type == '1'
                                ? 'entreprise'
                                : data.company?.type == '2'
                                ? 'esn-type'
                                : data.company?.type == '3'
                                ? 'client-type'
                                : 'cabinet-type'
                            "
                          >
                            {{
                              data?.company?.type == "1"
                                ? "Entreprise"
                                : data.company?.type == "2"
                                ? "ESN"
                                : data.company?.type == "3"
                                ? "Client Final"
                                : "Cabinet de
                                                        Recrutement"
                            }}</span
                          >
                        </td>
                        <td *ngIf="listNames.includes('Avis')">
                          <div class="stars">
                            <rating
                              [(ngModel)]="data.average_note"
                              [max]="5"
                              [readonly]="true"
                            >
                            </rating>
                          </div>
                        </td>
                        <td *ngIf="listNames.includes('Taille')">
                          <span>
                            {{
                              data.company?.size_company
                                ? data.company?.size_company
                                : "---"
                            }}</span
                          >
                        </td>

                        <td *ngIf="listNames.includes('Pays')">
                          <span
                            *ngIf="
                              data.company?.country !== null &&
                              data.company?.country !== 'null'
                            "
                            >{{ data.company?.country }}</span
                          >
                          <span
                            *ngIf="
                              !data.company?.country ||
                              data.company?.country === null ||
                              data.company?.country === 'null'
                            "
                            >---</span
                          >
                        </td>
                        <td *ngIf="listNames.includes('Ville')">
                          <span
                            *ngIf="
                              data.company?.city !== null &&
                              data.company?.city !== 'null'
                            "
                            >{{ data.company?.city }}</span
                          >
                          <span
                            *ngIf="
                              !data.company?.city ||
                              data.company?.city === null ||
                              data.company?.city === 'null'
                            "
                            >---</span
                          >
                        </td>
                        <td *ngIf="listNames.includes('Email')">
                          <span>
                            {{data.company?.ContactEmail || "---" }}
                          </span>
                        </td>

                        <td *ngIf="listNames.includes('N°Tel')">
                          <span>{{data.company?.ContactPhone
                              ? data.company?.ContactPhone
                              : "---"
                          }}</span>
                        </td>

                        <!-- <td *ngIf="listNames.includes('Dernière connexion')"> <span> {{ !data.last_connection ? '---' :data.last_connection.split('
                                                    ')[0].split('-').reverse().join('/') }}
                                                  </span>
                                                  </td> -->
                        <!-- <td>last connection</td> -->
                        <td class="td-fixed-3">
                        
                            <div class="dropdown" mat-button [matMenuTriggerFor]="menu">
                              <button
                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                <svg
                                  width="19"
                                  height="5"
                                  viewBox="0 0 19 5"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="2.44739"
                                    cy="2.44739"
                                    r="2.44739"
                                    transform="matrix(1 0 0 -1 0 4.89478)"
                                    fill="#265D91"
                                  />
                                  <circle
                                    cx="2.44739"
                                    cy="2.44739"
                                    r="2.44739"
                                    transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                    fill="#265D91"
                                  />
                                  <circle
                                    cx="2.44739"
                                    cy="2.44739"
                                    r="2.44739"
                                    transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                    fill="#265D91"
                                  />
                                </svg>
                              </button>
                              <mat-menu #menu="matMenu">
                                <a mat-menu-item
                                  class="dropdown-item btn-details"
                                  routerLink="/entreprises/details-entreprise/{{
                                    data.company.uuid
                                  }}"
                                  style="cursor: pointer"
                                  >Visualiser</a>
                                  <a mat-menu-item
                                  class="dropdown-item btn-details cursor-pointer"
                                  [ngClass]="{'disabled-button': unSubscribedEsn()  || data.company?.hasActiveSubscription === false}"
                                  *ngIf="!unSubscribedEsn()" 
                                  [href]="'/contact;idResponsable=' + data.company?.uuid + ';Type=' + data.company?.type"
                                  style="cursor: pointer"
                                >
                                  Contacter responsable
                                </a>

                                  <a mat-menu-item [href]="'/entreprises/offre-entreprise;id=' + data.company?.uuid"  >
                            Voir offres
                          </a>
                              </mat-menu>
                              
                            </div>
                        </td>
                        <td class="td-fixed-4"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

      <div class="pagination" *ngIf="listCampany && listCampany.length">
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                aria-label="Select page">
              </mat-paginator>
            </div>

      <app-empty-state *ngIf="listCampany && !listCampany.length"
      [title]="parentItem"></app-empty-state>
              </div>
            </div>
          </div>

          <!--end::Tab pane-->
        </div>

        <div class="tab-content for-mobile">
          <!--begin::Tab pane-->

          <div
            id="kt_project_targets_card_pane"
            class="tab-pane fade show active"
          >
            <!--begin::Row-->
            <div class="row g-6 g-xl-9 justify-content-center">
              <!--begin::Col-->
              <div
                class="col-md-6 col-xxl-4"
                *ngFor="let data of listCampany; let i = index"
              >
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="card-toolbar1">
                    <span
                      [ngClass]="
                        data?.company?.type == '1'
                          ? 'entreprise'
                          : data?.company?.type == '2'
                          ? 'esn-type'
                          : data?.company?.type == '3'
                          ? 'client-type'
                          : 'cabinet-type'
                      "
                      class="type-esn text-uppercase wrapping-company fw-bold"
                    >
                      {{
                        data?.company?.type == "1"
                          ? "Entreprise"
                          : data?.company.type == "2"
                          ? "ESN"
                          : data?.company.type == "3"
                          ? "Client Final"
                          : "Cabinet de
                                            Recrutement"
                      }}</span
                    >
                  </div>

                  <div class="tools">
                    <td class="actions">
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <svg
                              width="19"
                              height="5"
                              viewBox="0 0 19 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91"
                              />
                            </svg>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item btn-details"
                              routerLink="/entreprises/details-entreprise/{{
                                data.company.uuid
                              }}"
                              style="cursor: pointer"
                              >Visualiser</a
                            >
                            <a
                              class="dropdown-item cursor-pointer"
                              [ngClass]="{'disabled-button': unSubscribedEsn()  || data.company?.hasActiveSubscription === false}"
                              (click)="!unSubscribedEsn() && contactResponsableNavigation(data.company?.uuid)"
                              style="cursor: pointer"
                              >
                            Contacter le responsable
                            </a>

                            <a
                              class="dropdown-item"
                              style="cursor: pointer"
                              (click)="VoiroffreNavigation(data.company?.uuid)"
                              >Voir offres</a>
                          </div>
                        </div>
                      </div>
                    </td>
                  </div>
                  <!--begin::Card body-->
                  <div class="card-body d-flex flex-center flex-column">
                    <div class="symbol symbol-65px symbol-circle mb-5">
                      <img
                        *ngIf="data?.company?.logo"
                        class="table-img logo-img"
                        src="{{
                          url +
                            '/Company/file/gallery_company/' +
                            data?.company.logo
                        }}"
                        alt=""
                      />
                      <img
                        *ngIf="!data.company.logo"
                        class="table-img logo-img"
                        src="/assets/media/icons/avatar.jpg"
                        alt=""
                      />
                      <div
                        class="bg-success position-absolute top-100 ms-n3 mt-n3"
                      ></div>
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Name-->
                    <a
                      class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0"
                    >
                      Entreprise :
                      {{ data.company?.name ? data.company?.name : "---" }}
                    </a>

                    <div class="content-card">
                      <!--begin::Stats-->
                      <div class="py-3 px-4 mx-2">
                        <div class="badge-annee">
                          <span> Responsable :</span>
                          {{
                            data.company?.employee[0]?.user.first_name || "---"
                          }}
                          {{
                            data.company?.employee[0]?.user.last_name || "---"
                          }}
                        </div>
                      </div>
                      <div class="py-3 px-4 mx-2">
                        <div class="ratings">
                          <rating
                            [(ngModel)]="data.average_note"
                            [max]="5"
                            [readonly]="true"
                          >
                          </rating>
                        </div>
                      </div>

                      <!--end::Stats-->
                    </div>

                    <!--end::Info-->
                  </div>
                  <div class="foot p-5">
                    <div class="links">
                           <a
                            *ngIf="data?.company?.linkedin_link"
                            [href]="formatUrl(data.company.linkedin_link)"
                            target="_blank"
                          
                          >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 17 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_239_1206)">
                            <path
                              d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                              fill="#265D91"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_239_1206">
                              <rect width="17" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>

                      <a
                        *ngIf="data?.company?.website_link"
                        [href]="formatUrl(data.company.website_link)"
                        target="_blank"
                        ><svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.0410156"
                            y="0.0407715"
                            width="17.9592"
                            height="17.9592"
                            rx="3"
                            fill="#265D91"
                          />
                          <path
                            d="M8.72077 14.4082C5.4083 14.4082 2.73438 12.0017 2.73438 9.02045C2.73438 6.03922 5.4083 3.63269 8.72077 3.63269C12.0332 3.63269 14.7072 6.03922 14.7072 9.02045C14.7072 12.0017 12.0332 14.4082 8.72077 14.4082ZM8.72077 4.35106C5.8473 4.35106 3.53256 6.43432 3.53256 9.02045C3.53256 11.6066 5.8473 13.6898 8.72077 13.6898C11.5942 13.6898 13.909 11.6066 13.909 9.02045C13.909 6.43432 11.5942 4.35106 8.72077 4.35106Z"
                            fill="white"
                          />
                          <path
                            d="M11.833 10.3494C11.9128 9.91841 11.9128 9.48738 11.9128 9.02045C11.9128 8.55351 11.8729 8.12249 11.833 7.69147C11.7532 7.11677 11.5936 6.578 11.4339 6.07514C10.8353 4.60249 9.87746 3.63269 8.72009 3.63269C7.36317 3.63269 6.24571 4.96167 5.7668 6.90126C5.72689 7.08085 5.68698 7.22453 5.64707 7.40412C5.56725 7.90698 5.52734 8.44575 5.52734 9.02045C5.52734 9.48738 5.56725 9.91841 5.60716 10.3494C5.68698 10.9241 5.84662 11.4629 6.00626 11.9658C6.56499 13.4384 7.56272 14.4082 8.68018 14.4082C9.79764 14.4082 10.7954 13.4384 11.3541 11.9658C11.0747 12.0376 10.7555 12.0735 10.4362 12.1453C10.0371 13.1151 9.35864 13.6898 8.72009 13.6898C8.08154 13.6898 7.40308 13.1151 6.96408 12.1453C6.76453 11.7143 6.60489 11.1755 6.48517 10.6009C6.36544 10.098 6.32553 9.59514 6.32553 9.02045C6.32553 8.44575 6.36544 7.90698 6.48517 7.44004C6.52508 7.26045 6.56499 7.11677 6.60489 6.93718V6.90126C6.6448 6.72167 6.68471 6.578 6.76453 6.43432C6.80444 6.32657 6.84435 6.21881 6.88426 6.14698C6.88426 6.14698 6.88426 6.14698 6.88426 6.11106L6.96408 5.96738C6.96408 5.96738 6.96408 5.93147 7.00399 5.89555C7.40308 4.92575 8.08154 4.35106 8.72009 4.35106C9.35864 4.35106 10.0371 4.92575 10.4761 5.89555C10.6756 6.32657 10.8353 6.86534 10.955 7.44004C11.0747 7.94289 11.1146 8.44575 11.1146 9.02045C11.1146 9.59514 11.0747 10.098 10.9949 10.6009C11.2743 10.529 11.5536 10.4572 11.833 10.3494Z"
                            fill="white"
                          />
                          <path
                            d="M11.9933 6.61416C11.4745 6.43456 10.836 6.32681 10.1974 6.25497C9.7185 6.18314 9.23959 6.14722 8.72077 6.14722C8.20195 6.14722 7.72304 6.18314 7.24412 6.21905C7.16431 6.43456 7.04458 6.68599 6.96476 6.97334C7.52349 6.9015 8.08222 6.86558 8.72077 6.86558C9.35932 6.86558 9.91805 6.9015 10.4768 6.97334C11.1153 7.08109 11.714 7.22477 12.1929 7.40436C13.2704 7.83538 13.909 8.41007 13.909 8.98477C13.909 9.55946 13.2704 10.1701 12.1929 10.5652C11.714 10.7448 11.1153 10.8884 10.4768 10.9962C9.91805 11.1399 9.35932 11.1758 8.72077 11.1758C8.08222 11.1758 7.52349 11.1399 6.96476 11.0321C6.32621 10.9603 5.72757 10.8166 5.24866 10.6011C4.17111 10.206 3.53256 9.59538 3.53256 9.02069C3.53256 8.44599 4.17111 7.83538 5.24866 7.44028C5.28857 7.15293 5.36839 6.86558 5.44821 6.61416C3.81193 7.11701 2.73438 7.97905 2.73438 9.02069C2.73438 10.0623 3.81193 10.9244 5.44821 11.4272C5.96703 11.6068 6.60558 11.7146 7.24412 11.7864C7.72304 11.8582 8.20195 11.8582 8.72077 11.8582C9.23959 11.8582 9.7185 11.8223 10.1974 11.7864C10.836 11.7146 11.4745 11.5709 11.9933 11.4272C13.6296 10.9244 14.7072 10.0264 14.7072 9.02069C14.7072 8.01497 13.6296 7.11701 11.9933 6.61416Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </div>

                    <div class="plus">
                      <a
                        style="cursor: pointer"
                        routerLink="/entreprises/details-entreprise/{{
                          data.company.uuid
                        }}"
                        >Visualiser</a
                      >
                    </div>
                  </div>
                  <!--end::Card body-->
                </div>
                <!--end::Card-->
              </div>
              <!--end::Col-->
            </div>
            <!--end::Row-->
      <div class="pagination" *ngIf="listCampany && listCampany.length">
          <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
            [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
            aria-label="Select page">
          </mat-paginator>
        </div>
        <app-empty-state  *ngIf="listCampany && !listCampany.length"
        [title]="parentItem"></app-empty-state>
     
          </div>
          <!--end::Tab pane-->
          <!--begin::Tab pane-->
        

          <!--end::Tab pane-->
        </div>
        <!--end::Table-->
      </div>
     

      <!--end::Card body-->
    </div>
    <!--end::Card-->
    <!--begin::Modals-->
    <!--begin::Modal - Customers - Add-->

    <!--end::Modal - Customers - Add-->
    <!--begin::Modal - Adjust Balance-->

    <!--end::Modal - New Card-->
    <!--end::Modals-->
  </div>
  <!--end::Content container-->
</div>
